import Icon from 'components/base/Icon';
import Text, { Inline } from 'components/base/Text';
import { useEffect, useState } from 'react';
import SearchableMenu from 'components/SearchableMenu';
import { LabelItem } from 'components/LabelsList';
import { LabelStyled } from 'components/LabelsList.style';
import { PM_PROVIDERS } from 'common/constants/constants';
import usePmProvider from 'components/hooks/PM/usePmProvider';
import { LBButton } from '@linearb/buzz';

const descriptionMapByProvider = {
  [PM_PROVIDERS.JIRA]: 'Filter by issue type/s',
  [PM_PROVIDERS.AZURE_BOARDS]: 'Please select the Azure Work Item type'
};

export const SingleSelectMenuItem = ({
  title,
  buttonText,
  itemsList = [],
  isMultiple,
  selectedItems,
  setSelectedItems,
  maxSelected = null,
  isRequired = false,
  itemKey = 'id',
  titleKey = 'title',
  width = '20rem',
  showClearAll = false
}) => {
  const [anchorEl, setAnchorEl] = useState();
  const [searchFilterValue, setSearchFilterValue] = useState();
  const [currentSelectedItems, setCurrentSelectedItems] = useState([]);
  const [searchResultItemsList, setSearchResultItemsList] = useState(itemsList);
  const pmProvider = usePmProvider();

  const toggleSelectAll = bool => {
    setCurrentSelectedItems(
      bool ? itemsList?.map(item => ({ ...item, id: item[itemKey] })) : []
    );
  };

  useEffect(() => {
    setCurrentSelectedItems(
      selectedItems?.map(item => ({ ...item, id: item[itemKey] }))
    );
  }, [selectedItems]);

  const closeMenu = () => setAnchorEl(null);

  const deleteItem = id => {
    const filteredList = selectedItems.filter(
      ({ id: currentItemId }) => currentItemId !== id
    );
    setSelectedItems(filteredList);
  };

  const onItemClick = item => {
    const foundIndex = currentSelectedItems?.findIndex(
      ({ id: currentItemId }) => currentItemId === item.id
    );
    if (foundIndex > -1) {
      setCurrentSelectedItems(
        currentSelectedItems.filter(({ id }) => id !== item.id)
      );
    } else {
      setCurrentSelectedItems([...currentSelectedItems, { ...item }]);
    }
  };
  const menuItems = searchResultItemsList.map(
    ({ name, [itemKey]: id, statusCategory }) => ({
      title: name,
      id,
      statusCategory,
      onClick: () =>
        onItemClick({
          id,
          name,
          title: name
        })
    })
  );
  const saveItems = () => {
    setSelectedItems([...currentSelectedItems]);
    closeMenu();
  };

  const onSearch = searchValue => {
    const filtered = itemsList.filter(({ [titleKey]: titleValue }) =>
      titleValue.toLowerCase().includes(searchValue.toLowerCase())
    );
    setSearchResultItemsList([...filtered]);
  };

  return (
    <div className='mt-8 flex flex-col'>
      <div className='flex flex-col'>
        <Text size='medium' mb='0.5rem'>
          {isRequired && (
            <Inline size='medium' color='radicalRed'>
              *{' '}
            </Inline>
          )}
          {title}
        </Text>
        <div className='flex items-center'>
          <Text color='shuttleGray' maxWidth='100%' size='medium' mr='0.4rem'>
            {descriptionMapByProvider[pmProvider]}
          </Text>
        </div>

        <div className='my-4 flex max-w-full flex-wrap gap-2'>
          {selectedItems?.length ? (
            <LabelStyled
              items='center'
              wrap='wrap'
              width='fit-content'
              data-testid='label-item'
            >
              <LabelItem
                titleKey={titleKey}
                onDelete={(_, id) => deleteItem(id)}
                labelItem={{
                  key: title,
                  label: title,
                  values: selectedItems
                }}
              />
            </LabelStyled>
          ) : (
            <></>
          )}
          <>
            <div className='flex flex-row items-center gap-2'>
              <LBButton
                variant='outline'
                data-testid='add-filters-button'
                data-cy='select-issue-types-button'
                onClick={e => {
                  setAnchorEl(e.currentTarget);
                }}
              >
                <Icon color={'chambray'} name='Add' /> {buttonText}
              </LBButton>

              {showClearAll && (
                <LBButton
                  variant='ghost'
                  disabled={selectedItems.length === 0}
                  onClick={() => {
                    setSelectedItems([]);
                  }}
                >
                  Clear All
                </LBButton>
              )}
            </div>
          </>
        </div>
      </div>

      <SearchableMenu
        onSearch={onSearch}
        isSearchable
        selectedCheckboxes={currentSelectedItems}
        maxSelectedCheckboxes={maxSelected}
        menuItems={menuItems}
        anchorEl={anchorEl}
        isMultiple={isMultiple}
        saveItems={saveItems}
        actions={[
          /* eslint-disable react/jsx-key */
          <LBButton onClick={closeMenu} variant='outline'>
            Close
          </LBButton>,
          <LBButton onClick={saveItems}>Add</LBButton>
          /* eslint-enable react/jsx-key */
        ]}
        searchFilterValue={searchFilterValue}
        setSearchFilterValue={setSearchFilterValue}
        width={width}
        selectAllEnabled={true}
        toggleSelectAll={toggleSelectAll}
      />
    </div>
  );
};
